import { motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';
import styles from './Backdrop.module.scss';
import { createPortal } from 'react-dom';

interface BackDropProps {
  onClick?: () => void;
}

const Backdrop: FC<PropsWithChildren<BackDropProps>> = ({ children, onClick }) => {
  return createPortal(
    <motion.div
      onClick={onClick}
      className={styles.backdrop}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>,
    document.body
  );
};

export default Backdrop;
